/**
 * OrderDesk / orderdesker line item field extraction (no service imports).
 * Kept leaf-level to avoid circular deps with folder bridges / folder loaders.
 */

/**
 * @param {object|null|undefined} item
 * @returns {string}
 */
export function extractOrderDeskLineSku(item) {
  if (!item || typeof item !== 'object') return '';
  return String(
    item.sku ||
      item.code ||
      item.product_code ||
      item.product_sku ||
      item.product_id ||
      '',
  ).trim();
}

/**
 * Line quantity — Number/parseFloat-compatible (matches Production packing cells).
 * @param {object|null|undefined} item
 * @returns {number}
 */
export function extractOrderDeskLineQty(item) {
  if (!item || typeof item !== 'object') return 0;
  return Number(item.quantity ?? item.qty ?? item.amount ?? 0) || 0;
}
